import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

import { BaseComponent, CommunityService, ContentService, Course, environment, EventBusService, Lesson, UserService, Video } from "@mypxplat/xplat/core";
import { AppService, WebCommunityService } from "@mypxplat/xplat/web/core";
import { isThisQuarter } from "date-fns";
import { ClipboardService } from "ngx-clipboard";
import { NgxSpinnerService } from "ngx-spinner";
import { take, takeUntil } from "rxjs/operators";
import { AddEditAnnouncementComponent } from "../../modals";
import { DragulaService } from "ng2-dragula";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-manage-announcements",
  templateUrl: "manage-announcements.component.html",
  standalone: false,
})
export class ManageAnnouncementsComponent extends BaseComponent {
  constructor(
    userService: UserService,
    private _clipboardService: ClipboardService,
    public appService: AppService,
    public contentService: ContentService,
    public evenbusService: EventBusService,
    public communityService: WebCommunityService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.initManageAnnouncements();
  }

  public announcements = [];
  initManageAnnouncements() {
    this.communityService.getAnnouncements().then((result) => {
      this.announcements = result.map((ann) => {
        const d = ann.date?.toDate?.();
        if (d) {
          const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
          let h = d.getUTCHours();
          const min = d.getUTCMinutes().toString().padStart(2, "0");
          const ampm = h >= 12 ? "PM" : "AM";
          h = h % 12 || 12;
          ann.dateDisplay = `${months[d.getUTCMonth()]} ${d.getUTCDate()}, ${d.getUTCFullYear()} ${h}:${min} ${ampm}`;
          if (ann.timezone) ann.dateDisplay += ` (${ann.timezone})`;
        }
        return ann;
      });
    });
  }

  deleteAnnouncement(ann) {
    if (confirm("Are you sure you want to delete this announcement? This cannot be undone.")) {
      this.communityService.deleteAnnouncement(ann.id).then((result) => {
        this.initManageAnnouncements();
      });
    }
  }

  editAnnouncement(ann?) {
    const modalRef = this.appService.showModal(AddEditAnnouncementComponent, { size: "lg" });
    modalRef.componentInstance.announcement = ann;
    modalRef.componentInstance.announcementAdded.pipe(take(1)).subscribe((result) => {
      this.initManageAnnouncements();
    });
  }
}
